import React from "react";
import { useMessageSource } from "react-message-source";
import { OwnerType } from "./types";
import MultiForm from "../shared/components/multi-form";
import Person from "./person";
import { createDefaultOwnerData } from "./defaults";
import GTM from "../../util/tracking/gtm";
import {
  EventCategory,
  PERSON_ADDED_ACTION_VALUE,
} from "../../util/tracking/types";

interface PersonsProps {
  name: string;
  formData: OwnerType[];
  limit: number;
}

export const Persons: React.FC<PersonsProps> = ({
  name,
  formData,
  limit,
}: PersonsProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  return (
    <MultiForm
      name={name}
      formData={formData}
      removeButtonText={getMessage("ControllingOwner.removePerson-button")}
      addButtonText={getMessage("ControllingOwner.addPerson-button")}
      renderFormComponent={(data, dataPath) => (
        <Person owner={data} dataPath={dataPath} />
      )}
      limit={limit}
      createDefaultItemData={createDefaultOwnerData}
      onAddItem={() => {
        GTM.trackEvent(
          EventCategory.ControllingOwners,
          PERSON_ADDED_ACTION_VALUE,
        );
      }}
    />
  );
};
